import React, {FunctionComponent} from 'react';
import './Step.less';

interface StepProps {
	isActive?: boolean;
}

export const Step: FunctionComponent<StepProps> = ({isActive}) => {
	return (
		<div className={'step' + (isActive ? ' step--active' : '')}>
			<div className='step__marker'/>
		</div>
	);
};
